/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShadowDecision } from './ShadowDecision';
import {
    ShadowDecisionFromJSON,
    ShadowDecisionFromJSONTyped,
    ShadowDecisionToJSON,
    ShadowDecisionToJSONTyped,
} from './ShadowDecision';

/**
 * 
 * @export
 * @interface GetLeadShadowDecision200Response
 */
export interface GetLeadShadowDecision200Response {
    /**
     * 
     */
    data?: ShadowDecision;
}

/**
 * Check if a given object implements the GetLeadShadowDecision200Response interface.
 */
export function instanceOfGetLeadShadowDecision200Response(value: object): value is GetLeadShadowDecision200Response {
    return true;
}

export function GetLeadShadowDecision200ResponseFromJSON(json: any): GetLeadShadowDecision200Response {
    return GetLeadShadowDecision200ResponseFromJSONTyped(json, false);
}

export function GetLeadShadowDecision200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeadShadowDecision200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ShadowDecisionFromJSON(json['data']),
    };
}

export function GetLeadShadowDecision200ResponseToJSON(json: any): GetLeadShadowDecision200Response {
    return GetLeadShadowDecision200ResponseToJSONTyped(json, false);
}

export function GetLeadShadowDecision200ResponseToJSONTyped(value?: GetLeadShadowDecision200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ShadowDecisionToJSON(value['data']),
    };
}

